import { ReactionType } from '../../../types';

export const LOTTIE_ANIMATIONS: Record<ReactionType, string | null> = {
    [ReactionType.Hello]: '1F44B.lottie',
    [ReactionType.Heart]: '2764_FE0F.lottie',
    [ReactionType.ThumbsUp]: '1F44D.lottie',
    [ReactionType.Clap]: '1F44F.lottie',
    [ReactionType.Party]: 'party.lottie',
    [ReactionType.Fire]: '1F525.lottie',
    [ReactionType.Laugh]: '1F923.json',
    [ReactionType.Thinking]: '1F914.lottie',
    [ReactionType.Angry]: '1F620.lottie',
    [ReactionType.ThumbsDown]: '1F44E.lottie',
    [ReactionType.Tears]: '1F62D.lottie',
    [ReactionType.Poop]: '1F4A9.lottie',
};
